
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability/spare-parts",
      function () {
        return require("private-next-pages/sustainability/spare-parts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability/spare-parts"])
      });
    }
  